import { fbAuth } from '@/services/auth'
import db from '@/services/db'

class AuthStatusCheck {
  /**
  * Init and read required data from db then check access
  * @param {object} store - vuex store instance
  * @param {object} route - router instance
  */
  constructor (store, router) {
    this.$store = store
    this.$router = router
    this.ls = window.localStorage

    this.init()
  }

  /**
  * Init function that handle check
  */
  async init () {
    this.$store.commit('reset')

    await new Promise((resolve) => {
      db.root.ref('isNFLApp').once('value', (snapshot) => {
        this.isNFLApp = snapshot.val()

        resolve()
      })
    })
    fbAuth().onAuthStateChanged((fbUser) => {
      this.$store.commit('setAuthStateChecked', false)

      this.curPath = document.location.pathname
      this.user = fbUser

      this.user = fbUser

      if (fbUser) {
        const user = {
          uid: this.user.uid,
          displayName: this.user.displayName,
          photoURL: this.user.photoURL,
          email: this.user.email,
          emailVerified: this.user.emailVerified,
          phoneNumber: this.user.phoneNumber,
          isAnonymous: this.user.isAnonymous,
          providerData: this.user.providerData
        }

        window.fbUser = user
      } else {
        window.fbUser = null
      }

      if (this.user) this.$store.commit('setUserId', this.user.uid)

      if (this.isNFLApp) this.handleNFLAuthScenario()
      else this.handleDefaultAuthScenario()

      if (this.isNFLApp) this.$store.commit('setAsNFLApp', true)
      else this.$store.commit('setAsNFLApp', false)
      this.$store.commit('setAuthStateChecked', true)
    })
  }

  // Default Auth Scenario

  handleDefaultAuthScenario () {
    if (this.user) this.handleDefaultAuthorized()
    else this.handleDefaultUnauthorized()
  }

  handleDefaultAuthorized () {
    const pageName = this.$router.history.current.name
    if (
      pageName !== 'Dashboard' &&
      pageName !== 'Forbidden' &&
      pageName !== 'Away'
    ) {
      //this.$router.push('/dashboard/-LJvhjWDjl6xyPGlag1H?tab=-LK6CV6f7PS3Y54zQY4B')
      this.$router.push('/dashboard/-LJT7DKABy1q69wb70tZ')
    }
  }

  handleDefaultUnauthorized () {
    const pageName = this.$router.history.current.name
    if (pageName !== 'Dashboard' && pageName !== 'Forbidden') {
      if (this.curPath !== '/auth') this.$router.push('/auth')
    }
  }

  // NFL Auth Scenario

  handleNFLAuthScenario () {
    new Promise((resolve) => {
      db.root.ref('redirects').once('value', (snapshot) => {
        this.redirects = snapshot.val()
        resolve()
      })
    }).then(() => {
      return new Promise((resolve) => {
        db.root.ref('access/Admin').once('value', (snapshot) => {
          this.admins = Object.keys(snapshot.val())
          resolve()
        })
      })
    }).then(() => {
      if (this.user) this.handleNFLAuthorized()
      else this.handleNFLUnauthorized()
    })
  }

  /**
  * Method handles authorized users
  */
  handleNFLAuthorized () {
    if (this.user.isAnonymous) {
      this.$store.commit('markUserAsAnonymous', true)
    } else {
      this.$store.commit('markUserAsAnonymous', false)
    }

    if (~this.admins.indexOf(this.user.uid)) {
      if (this.$router.history.current.name !== 'Dashboard') {
        this.$router.push('/home')
      }
    } else {
      if (this.$router.history.current.name !== 'Dashboard') {
        this.$router.push(this.redirects.defaultDash)
      }
    }
  }

  /**
  * Method handles unauthorized users
  */
  handleNFLUnauthorized () {
    this.ls.removeItem('uid')

    if (this.curPath !== '/auth' && this.curPath !== '/goaway') {
      document.location = this.redirects.toSSO
    }
  }
}

export default AuthStatusCheck



// WEBPACK FOOTER //
// ./src/helpers/auth-status-check.js